import React from "react";
import "./Technology.scss";
import images from "../../Data/images";
import { FaPhoneAlt } from "react-icons/fa";
import TechnologySection from "./Techsection";
import { motion } from "framer-motion";

const Technology = () => {
  return (
    <div className="technology">
      <div className="bg-[#c4122f] text-white py-16 px-6 md:px-20 flex flex-col md:flex-row justify-between items-center gap-6">
        <div>
          <h1 className="text-4xl font-bold mb-4">TECHNOLOGY</h1>
          <p className="text-lg max-w-xl">
            Nationwide High-Quality Security Services
          </p>
        </div>
      </div>
      {/* Breadcrumb and Contact */}
      <div className="flex justify-between items-center py-4 px-6 md:px-20 border-b">
        <span className="text-sm text-gray-500">HOME / TECHNOLOGY</span>
        <span className="flex items-center gap-2 text-sm text-gray-700">
          <FaPhoneAlt className="text-[#c4122f]" />
          +1 (416) 477-7692
        </span>
      </div>

    <TechnologySection/>

    <section className="py-20 px-6 md:px-20 text-gray-800 space-y-24">

  {/* Surveillance Camera Systems */}
  <div className="grid md:grid-cols-2 gap-14 items-center">
    
    <motion.div
      initial={{opacity:0,x:-60}}
      whileInView={{opacity:1,x:0}}
      transition={{duration:0.6}}
    >
      <h2 className="text-4xl font-bold text-[#c4122f] mb-4">
        Surveillance Camera Systems
      </h2>

      <p className="mb-4">
        CCTV systems provide continuous monitoring and documentation of activity across your property.
      </p>

      <ul className="space-y-2">
        <li>• High-definition video monitoring</li>
        <li>• Interior and exterior camera coverage</li>
        <li>• Parking lot and perimeter surveillance</li>
        <li>• Night vision and low-light monitoring</li>
        <li>• Video recording and evidence documentation</li>
        <li>• Remote viewing capabilities</li>
      </ul>

      <p className="mt-4">
        These systems help deter criminal activity and provide valuable evidence when incidents occur.
      </p>
    </motion.div>

    <motion.div
      initial={{opacity:0,scale:0.9}}
      whileInView={{opacity:1,scale:1}}
      transition={{duration:0.6}}
    >
      <img
        src={images.service6}
        alt="CCTV Surveillance Systems"
        className="w-full rounded-xl shadow-xl"
      />
    </motion.div>

  </div>


  {/* Access Control Systems */}
  <div className="grid md:grid-cols-2 gap-14 items-center">

    <motion.div
      initial={{opacity:0,scale:0.9}}
      whileInView={{opacity:1,scale:1}}
      transition={{duration:0.6}}
    >
      <img
        src={images.service4}
        alt="Access Control Systems"
        className="w-full rounded-xl shadow-xl"
      />
    </motion.div>

    <motion.div
      initial={{opacity:0,x:60}}
      whileInView={{opacity:1,x:0}}
      transition={{duration:0.6}}
    >
      <h2 className="text-4xl font-bold text-[#c4122f] mb-4">
        Access Control Systems
      </h2>

      <p className="mb-4">
        Access control technology allows property owners to manage who enters buildings and restricted areas.
      </p>

      <ul className="space-y-2">
        <li>• Keycard and fob entry systems</li>
        <li>• Keypad access control</li>
        <li>• Electronic door locks</li>
        <li>• Secure entry systems for commercial and residential buildings</li>
        <li>• Entry logs and activity tracking</li>
      </ul>

      <p className="mt-4">
        Access control improves building security while maintaining convenient access for authorized personnel.
      </p>
    </motion.div>

  </div>


  {/* Mobile Surveillance */}
  <div className="grid md:grid-cols-2 gap-14 items-center">

    <motion.div
      initial={{opacity:0,x:-60}}
      whileInView={{opacity:1,x:0}}
      transition={{duration:0.6}}
    >
      <h2 className="text-4xl font-bold text-[#c4122f] mb-4">
        Mobile Surveillance & Remote Monitoring
      </h2>

      <p className="mb-4">
        Technology allows security teams to monitor properties more effectively even when guards are not physically present.
      </p>

      <ul className="space-y-2">
        <li>• Mobile surveillance camera systems</li>
        <li>• Remote monitoring capabilities</li>
        <li>• Digital reporting and documentation</li>
        <li>• Real-time communication between personnel and dispatch</li>
      </ul>
    </motion.div>

    <motion.div
      initial={{opacity:0,scale:0.9}}
      whileInView={{opacity:1,scale:1}}
      transition={{duration:0.6}}
    >
      <img
        src={images.service14}
        alt="Remote Monitoring"
        className="w-full rounded-xl shadow-xl"
      />
    </motion.div>

  </div>


  {/* Drone Security Technology */}
  <div className="grid md:grid-cols-2 gap-14 items-center">

    <motion.div
      initial={{opacity:0,scale:0.9}}
      whileInView={{opacity:1,scale:1}}
      transition={{duration:0.6}}
    >
      <img
        src={images.drone}
        alt="Drone Security Technology"
        className="w-full rounded-xl shadow-xl"
      />
    </motion.div>

    <motion.div
      initial={{opacity:0,x:60}}
      whileInView={{opacity:1,x:0}}
      transition={{duration:0.6}}
    >
      <h2 className="text-4xl font-bold text-[#c4122f] mb-4">
        Drone Security Technology
      </h2>

      <p className="mb-4">
        Drone technology is becoming an increasingly valuable tool in modern security operations.
      </p>

      <ul className="space-y-2">
        <li>• Large property monitoring</li>
        <li>• Construction site surveillance</li>
        <li>• Property inspections</li>
        <li>• Perimeter monitoring</li>
      </ul>
    </motion.div>

  </div>


  {/* Integrated Security */}
  <div className="grid md:grid-cols-2 gap-14 items-center">

    <motion.div
      initial={{opacity:0,x:-60}}
      whileInView={{opacity:1,x:0}}
      transition={{duration:0.6}}
    >
      <h2 className="text-4xl font-bold text-[#c4122f] mb-4">
        Integrated Security Solutions
      </h2>

      <p className="mb-4">
        The most effective security programs combine trained personnel with advanced technology.
      </p>

      <ul className="space-y-2">
        <li>• Security guards</li>
        <li>• Mobile patrol services</li>
        <li>• CCTV surveillance systems</li>
        <li>• Access control systems</li>
        <li>• Digital reporting and monitoring tools</li>
      </ul>

      <p className="mt-4">
        This integrated approach provides stronger protection and greater visibility across your property.
      </p>
    </motion.div>

    <motion.div
      initial={{opacity:0,scale:0.9}}
      whileInView={{opacity:1,scale:1}}
      transition={{duration:0.6}}
    >
      <img
        src={images.s2robot}
        alt="Integrated Security"
        className="w-full rounded-xl shadow-xl"
      />
    </motion.div>

  </div>

</section>

    </div>
  );
};

export default Technology;
